import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { useStripeCheckout } from "../hooks/useStripeCheckout";
import React from "react";
import { useNavigate } from "react-router-dom";

interface CardCheckoutProps {
  cost: number;
  property_id: number;
  quantity: number;
}

export default function CardCheckout({ cost, property_id, quantity }: CardCheckoutProps) {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const { checkout } = useStripeCheckout();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!stripe || !elements) {
      alert("Stripe não carregado corretamente.");
      return;
    }

    const cardElement = elements.getElement(CardElement);
    if (!cardElement) {
      alert("Elemento de cartão não encontrado.");
      return;
    }

    const data = await checkout({
      amount: cost,
      cardElement,
      stripe,
      property_id,
      quantity,
    });

    if (data.payment_status == "succeeded") {
      navigate("/homeBuy");
    }
  };

  return (
    <div className="flex justify-center items-center w-full">
      <form
        onSubmit={handleSubmit}
        className="bg-white shadow-md rounded-2xl p-8 w-full"
      >
        <h2 className="!text-2xl !font-bold !mb-6 text-center text-gray-800">
          Pagamento com Cartão
        </h2>

        <div className="border border-gray-300 rounded-md p-4 mb-6 bg-white focus-within:ring-2 focus-within:ring-blue-500">
          <CardElement
            options={{
              style: {
                base: {
                  fontSize: "16px",
                  color: "#32325d",
                  padding: "24px",
                  "::placeholder": {
                    color: "#a0aec0",
                  },
                },
                invalid: {
                  color: "#e53e3e",
                },
              },
            }}
          />
        </div>

        <button
          type="submit"
          className="!w-full !bg-blue-600 !hover:bg-blue-700 !text-white !font-semibold !py-2 !px-4 !rounded-md !transition !duration-300"
        >
          Realizar pagamento
        </button>
      </form>
    </div>
  );
}
